var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"working-activity.create.label","bread-crumb-data":_vm.breadCrumbData}},[(_vm.activity)?_c('working-activity-form',{attrs:{"activity":_vm.activity}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }